import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CardService } from '../../../shared/services/card.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SessionService } from '../../../shared/services/session.service';
import { CreditCardValidators } from 'angular-cc-library';
import { CreditCard } from '../../../model/credit.card';
import { CardSession } from '../../../model/card.session';
import { ExpirationDateUtil } from '../../../model/util/expiration-date-util';
import { NzModalRef, NzModalService } from 'ng-zorro-antd';
import { AccountEulaComponent } from '../../../shared/notification/account-eula/account-eula.component';
import { CardEulaComponent } from '../../../shared/notification/card-eula/card-eula.component';
import { TextService } from '../../../shared/services/text.service';
import { SdkInitText } from '../../../model/user/sdk-init-text';
import { NetmeraService } from "../../../shared/services/netmera-service";
import { KartEkle } from "../../../model/netmera-events/kart-ekle";
import { Error } from "../../../model/netmera-events/error";

@Component({
  selector: 'pa-add-card',
  templateUrl: './add-card.component.html',
  styleUrls: ['./add-card.component.scss']
})
export class AddCardComponent implements OnInit {
  submitted = false;
  showCvv = false;
  threedWithCardAdd = false;
  request: CreditCard;
  errorMessage: string;
  cardLogo: string;
  tplModal: NzModalRef;
  textService: TextService;
  loading: boolean=false;
  trackingId: string;
  merchantCode: string;
  sdkInitTexts: Array<SdkInitText>;

  cardAddForm = new FormGroup({
    cardNumber: new FormControl('', [Validators.required, Validators.maxLength(20), CreditCardValidators.validateCCNumber]),
    expirationDate: new FormControl('', [Validators.required, CreditCardValidators.validateExpDate]),
    cvv: new FormControl(''),
    cardName: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(50)]),
    isEngagementAccepted: new FormControl('', [Validators.requiredTrue])
  });

  constructor(private router: Router, private route: ActivatedRoute, private cardService: CardService,
              private sessionService: SessionService, private modalService: NzModalService, textService: TextService,
              private netmeraService: NetmeraService, private kartEkle: KartEkle, private error: Error) {
    this.textService = textService;
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      let sessionId: string = params.sessionId;
      this.trackingId = params.trackingId;
      if (sessionId != null) {
        this.loading = true;
        let cardSession = new CardSession();
        cardSession.threedSessionId = sessionId;
        cardSession.token = "";
        this.cardService.addThreeD(cardSession, this.trackingId).subscribe(
          response => {
            this.loading = false;
            if (response.threeDResult) {
              this.errorMessage = response.threeDResult;
              this.netmeraService.pushEvent(this.kartEkle.setEventObject("KartEkleBasarisiz"));
              this.netmeraService.pushEvent(this.error.setEventObject("KartEkleBasarisiz", this.merchantCode));
            } else {
              this.netmeraService.pushEvent(this.kartEkle.setEventObject("KartEkleBasarili"));
              this.router.navigate(['/payment/selection', this.trackingId]);
            }
          },
          error => {
            this.netmeraService.pushEvent(this.kartEkle.setEventObject("KartEkleBasarisiz"));
            this.netmeraService.pushEvent(this.error.setEventObject("KartEkleBasarisiz", this.merchantCode));
            this.loading = false;
            this.router.navigate(['/result/error', this.trackingId]);
          }
        )
      }

    })
    this.getUser();
  }

  getUser() {
    this.sessionService.getInitUser(this.trackingId).subscribe(response => {
      this.sdkInitTexts = response.sdkInitTexts;
      this.showCvv = response.merchantCvvRequired;
      this.merchantCode = response?.requestHeader?.merchant?.merchantCode;
      if (this.showCvv) {
        this.cardAddForm.controls["cvv"].setValidators([Validators.required, Validators.minLength(3)]);
      }
      this.threedWithCardAdd = response.cardThreeDEnabled;
    }, error => {
      this.router.navigate(['/result/error', this.trackingId]);
    });
  }

  addCard() {
    this.submitted = true;
    if (this.cardAddForm.invalid) {
      return;
    }
    this.request = new CreditCard();
    this.request.name = this.cardAddForm.value.cardName;
    this.request.cardNumber = this.cardAddForm.value.cardNumber;
    this.request.month = parseInt(ExpirationDateUtil.takeMonthFromExpirationDate(this.cardAddForm.value.expirationDate));
    this.request.year = parseInt(ExpirationDateUtil.takeYearFromExpirationDate(this.cardAddForm.value.expirationDate));
    this.request.cvv = this.cardAddForm.value.cvv;

    if (this.threedWithCardAdd) {
      this.cardService.createThreeDSession(this.request, this.trackingId).subscribe(
        response => {
          this.router.navigate(['/payment/threeD', this.trackingId], {
            queryParams: {
              sessionId: response.threedSessionId,
              token: response.token
            }
          });
        },
        error => {
          this.netmeraService.pushEvent(this.kartEkle.setEventObject("KartEkleBasarisiz"));
          this.netmeraService.pushEvent(this.error.setEventObject("KartEkleBasarisiz", this.merchantCode));
          this.router.navigate(['/result/error', this.trackingId]);
        }
      );
    } else {
      this.cardService.addCard(this.request, this.trackingId).subscribe(
        response => {
          if (response.threeDResult) {
            this.netmeraService.pushEvent(this.kartEkle.setEventObject("KartEkleBasarisiz"));
            this.netmeraService.pushEvent(this.error.setEventObject("KartEkleBasarisiz", this.merchantCode));
            this.errorMessage = response.threeDResult;
          } else {
            this.netmeraService.pushEvent(this.kartEkle.setEventObject("KartEkleBasarili"));
            this.router.navigate(['/payment/selection', this.trackingId]);
          }
        },
        (error: any) => {
          this.netmeraService.pushEvent(this.kartEkle.setEventObject("KartEkleBasarisiz"));
          this.netmeraService.pushEvent(this.error.setEventObject("KartEkleBasarisiz", this.merchantCode));
          this.router.navigate(['/result/error', this.trackingId]);
        }
      )
    }
  }

  onCardChange(e): void {
    const val = e.target.value;
    this.cardLogo = this.manageCardType(val);
  }

  manageCardType(number) {

    let re = new RegExp("^4");
    if (number.match(re) != null)
      return "visacard";

    re = new RegExp("^(34|37)");
    if (number.match(re) != null)
      return "amexcard";

    re = new RegExp("^5[1-5]");
    if (number.match(re) != null)
      return "mastercard";

    re = new RegExp("^6011");
    if (number.match(re) != null)
      return "defaultcard";

    return "defaultcard";
  }

  createAccountEulaModal(): void {
    this.tplModal = this.modalService.create({
      nzClassName: 'account-eula-modal',
      nzContent: AccountEulaComponent,
      nzMaskClosable: true,
      nzClosable: true,
      nzFooter: null,
      nzStyle: {
        width: '513px',
        height: '680px',
        'border-radius': '15px',
        'box-shadow': '0 0 15px 0 rgba(0, 0, 0, 0.25)',
        'background-color': '#ffffff'
      },
      nzComponentParams: {trackingId: this.trackingId}
    });
  }

  createCardEulaModal(): void {
    this.tplModal = this.modalService.create({
      nzClassName: 'card-eula-modal',
      nzContent: CardEulaComponent,
      nzMaskClosable: true,
      nzClosable: true,
      nzFooter: null,
      nzStyle: {
        width: '513px',
        height: '680px',
        'border-radius': '15px',
        'box-shadow': '0 0 15px 0 rgba(0, 0, 0, 0.25)',
        'background-color': '#ffffff'
      },
      nzComponentParams: {trackingId: this.trackingId}
    });
  }
  messageState(value: any) {
    this.errorMessage = value;
  }
}
